<template>
  <CModal
    @mtdclosemodal="mtdClose"
    :show="boo_modal"
    :title="title"
    :size="'lg'"
    :centered="true"
    :btn_cancel="true"
    :btn_ok="true"
    :booTitile="true"
  >
    <div class="container">
      <CRow>
        <CCol>
          <div class="table-responsive">
            <table
              class="table table-sm table-hover table-striped table-bordered dt-responsive nowrap"
              style="width: 100%"
            >
              <thead>
                <tr>
                  <th width="40">#</th>
                  <th>Fecha</th>
                  <th>Método</th>
                  <th>Comprobante</th>
                  <th>Monto</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(charge, index) in item" :key="index">
                  <td>{{ index + 1 }}</td>
                  <td>{{ formatDate(charge.created_at) }}</td>
                  <td>{{ charge.method }}</td>
                  <td>
                    {{ charge.voucher ? charge.voucher.serie + "-" + charge.voucher.number : "-" }}
                  </td>
                  <td>{{ mtdMoney(charge.amount) }}</td>
                </tr>
                <tr v-if="item.length === 0">
                  <td colspan="5" class="text-center">Sin pagos registrados</td>
                </tr>
                <tr v-else>
                  <td colspan="4" class="text-end"><strong>Total:</strong></td>
                  <td><strong>{{ mtdMoney(totalSum) }}</strong></td>
                </tr>
              </tbody>
            </table>
          </div>
        </CCol>
      </CRow>
    </div>
    <template #footer>
      <CButton class="btn-secondary" @click="mtdClose" :style="{ color: 'black' }">
        <i class="fa fa-times"></i>&nbsp;Cerrar
      </CButton>
    </template>
  </CModal>
</template>
<script>
import CModal from "../../../shared/modals/cModalFormCom.vue";
import moment from "moment";

export default {
  name: "c-history-credits-modal",
  components: {
    CModal,
  },
  props: {
    title: String,
    boo_modal: Boolean,
    item: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    totalSum() {
      return this.item.reduce(
        (sum, charge) => sum + (parseFloat(charge.amount) || 0),
        0
      );
    },
  },
  methods: {
    mtdClose() {
      this.$emit("closeModalHistoryCredits");
    },
    formatDate(date) {
      return date ? moment(date).format("DD/MM/YYYY") : "-";
    },
    mtdMoney(value) {
      return "S/. " + parseFloat(value || 0).toFixed(2);
    },
  },
};
</script>
